<template>
  <div class="goods-detail-page budo-3">
    <div class="content-box">
      <div class="box1">
        <van-swipe @change="onChange">
          <van-swipe-item v-for="(item, index) of images" :key="index">
            <div v-if="goodsDetail.stock < 1" class="goods-stock">
              <img src="images/goods_stock.png" width="300" />
            </div>
            <van-image
              :src="item"
              fit="fill"
              height="280px"
              width="100vw"
            ></van-image>
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              {{ current + 1 }}/{{ images?.length }}
            </div>
          </template>
        </van-swipe>
      </div>
      <div class="box2">
        <div class="goods-name">
          <van-tag
            v-for="tag in goodsDetail.tags"
            :key="tag"
            color="#f55519"
            size="medium"
            style="
              display: block;
              float: left;
              margin-top: 6px;
              margin-right: 4px;
            "
            >{{ tag }}
          </van-tag>
          &nbsp;{{ goodsDetail.name }}
        </div>
      </div>

      <!-- 商品详情  -->
      <div style="background-color: #fff">
        <p>
          <img
            class="goods-detail-img"
            v-for="(item, index) in goodsDetail.detail"
            :key="index"
            :src="item"
            alt=""
            style="margin: 0; padding: 0; vertical-align: bottom"
            width="100%"
          />
        </p>
        <div style="padding: 15px">
          <div
            class="rich-text goods-detail-notice"
            v-html="goodsDetail.notice"
          ></div>
        </div>

        <gas-map v-if="goodsDetail.supplierId === 150"></gas-map>
      </div>

      <div class="box6 flex-row"></div>
    </div>
  </div>
</template>

<script>
import { api_get_goods_by_id } from "@/api/goods-api";
import GoodsSpec from "@/components/common/goods-spec";
import GoodsUnit from "@/components/common/goods-unit";
import { mall_util_order_buy_goods } from "@/util/orders";
import { GOODS_TYPE_GENERAL_GOODS } from "@/api/constant";
import { getBrandShopListById } from "@/api/sys-api";
import GasMap from "@/components/common/gas-map";

export default {
  name: "detail",
  components: { GasMap, GoodsSpec, GoodsUnit },
  data() {
    return {
      visibleSpecWin: false,
      goodsId: 0,
      current: 0,
      recommend: [],
      goodsDetail: {},
      //address: this.$store.getters.address,
      images: [],
      multipleSpec: false,
      specValue: [],
      expressName: "",
      brand: {},
      brandShopVisible: false,
      brandShopRegion: 0,
      brandShopList: [],
      selectedBrandShopList: [],
      visibleBrandShop: false,
      topicId: 0,
    };
  },
  computed: {
    goodsCount: function () {
      const cart = this.$store.getters.cart;
      if (cart && Array.isArray(cart) && cart.length > 0) {
        return cart.length;
      }
      return 0;
    },
    goodsStock: function () {
      return this.goodsDetail.stock;
    },
    address: function () {
      return this.$store.getters.address;
    },
  },

  created() {
    this.goodsId = this.$route.query.goodsId || 0;
    this.topicId = this.$route.query.topicId || 0;
    this.getGoodsInfo();
    // window.location.reload();
  },

  methods: {
    toGoodList(path) {
      if (this.$route.name != path) {
        this.$router.push({ path });
      }
    },

    getGoodsInfo() {
      api_get_goods_by_id(this.goodsId).then((res) => {
        this.goodsDetail = {
          ...res.data,
          isAddCard:
            res.data.goodsType === GOODS_TYPE_GENERAL_GOODS &&
            res.data.onlyTimesCard === 0,
        };
        this.images = res.data.images;
      });
    },

    addCart() {
      if (this.multipleSpec) {
        this.showSpec();
      } else {
        mall_util_order_buy_goods(this.goodsDetail.goodsId, 1, true);
      }
    },

    toBuy() {
      if (this.multipleSpec) {
        this.showSpec();
      } else {
        mall_util_order_buy_goods(
          this.goodsDetail.goodsId,
          1,
          false,
          null,
          0,
          this.topicId
        );
      }
    },

    onChange(index) {
      this.current = index;
    },

    showSpec() {
      this.visibleSpecWin = true;
      this.$refs.spec.initSpecInfo();
    },

    specValueChange(value) {
      this.specValue = value.selectedSkuComb.id;
    },

    showShopList(brandId) {
      this.brandShopVisible = true;
      this.brandShopList = [];
      getBrandShopListById(brandId).then((res) => {
        let index = 1;
        let allShopList = [];

        for (const data in res.data) {
          allShopList = [...allShopList, ...res.data[data]];
        }

        budo_log.info("#169", allShopList);

        this.brandShopList.push({
          index: 0,
          region: "全部",
          count: allShopList.length,
          list: allShopList,
        });

        for (const key in res.data) {
          this.brandShopList.push({
            index: index,
            region: key,
            count: res.data[key].length,
            list: res.data[key],
          });
          index++;
        }

        this.brandShopOnChange(0);
      });
    },

    brandShopOnChange(index) {
      budo_log.info("#192 brandShopOnChange", index);
      this.selectedBrandShopList = this.brandShopList.find(
        (s) => s.index === index
      ).list;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "detail";

::v-deep .health-detail {
  line-height: 18px;
}

.goods-stock {
  float: left;
  width: 300px;
  z-index: 999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>
